const locale = {
    build: {
        errorGeneric: "We couldn't build your store. Please try again.",
    },
    gallery: {
        title: "What will you build?",
        subtitle: "Start from a template and shape it to your business.",
        cardCta: "Use this one",
        tabAll: "All",
        tabStores: "Stores",
        tabServices: "Services",
        tabPortfolios: "Portfolios",
    },
    form: {
        title: "Create your store with Artificial Intelligence",
        description: "Describe the theme of your store and the products you sell.",
        exampleText: "Examples",
        placeholder: "Tell us about your ideal store",
        buttonCreateStore: "Build my store",
        placeholderExamples: [
            "A minimalist jewelry store that takes card and PayPal",
            "A specialty coffee shop with same-day delivery",
            "A hardware store that answers customers on WhatsApp",
            "A sportswear brand with installment payments",
            "A flower shop with nationwide shipping",
            "An architecture studio that collects payments with Stripe",
            "A pet store with automated order tracking",
        ],
        defaultDescription: "Create me a minimalist style jewelry store, pastel colors and with 4 golden products.",
        characters: "characters",
        minimumCharacters: "Minimum 10 characters",
    },
    loader: {
        stepOne: "Choosing the best design for your business...",
        stepTwo: "Selecting the best images for your catalog...",
        stepThree: "We are creating your store with AI...",
    },
    footer: {
        leftButton: {
            label: "See other option",
        },
        rightButton: {
            label: "Start",
        }
    },
    errors: {
        timeout: "Creation took too long, please try again",
        generic: "An error occurred, please try later",
    }
};

export default locale;